var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcPlayerArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.06 14.713l-22.5-13.5a5.006 5.006 0 00-5.04-.065 5.007 5.007 0 00-2.536 4.35v27.005c0 1.8.97 3.46 2.535 4.35a4.994 4.994 0 005.04-.065l22.5-13.5a5.001 5.001 0 000-8.575z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml,%3Csvg width='34' height='38' viewBox='0 0 34 38' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M31.0594 14.7126L8.55937 1.21261C7.00938 0.287615 5.09438 0.257615 3.51938 1.14761C1.95438 2.03761 0.984375 3.69761 0.984375 5.49761V32.5026C0.984375 34.3026 1.95438 35.9626 3.51938 36.8526C4.28938 37.2876 5.13438 37.5026 5.98438 37.5026C6.87437 37.5026 7.76937 37.2626 8.55937 36.7876L31.0594 23.2876C32.5644 22.3826 33.4844 20.7576 33.4844 18.9976C33.4844 17.2426 32.5644 15.6176 31.0594 14.7126Z' fill='white'/%3E %3C/svg%3E";
export { SvgIcPlayerArrow as ReactComponent };